import ResourceModel from "sap/ui/model/resource/ResourceModel";
import Component from "../Component";
import ResourceBundle from "sap/base/i18n/ResourceBundle";

export function GetDynamicTranslation(
  oComponent: Component,
  translationKey: string
): string {
  if (!translationKey) return "";

  const dynTranslationsModel = oComponent.getModel(
    "i18n_dynamic"
  ) as ResourceModel;

  const dynTransBundle =
    dynTranslationsModel.getResourceBundle() as ResourceBundle;

  if (dynTransBundle.hasText(translationKey))
    return dynTransBundle.getText(translationKey) as string;

  // reload page to refresh dynamic translations
  const lastTranslationRefreshTime = localStorage.getItem(
    "lastTranslationRefreshTime"
  );
  const timeNow = new Date().getTime();
  // check that the last time the page was refreshed was more than 10 seconds ago to avoid infinite reload loop

  if (translationKey === "*") {
    return translationKey;
  }

  if (
    !lastTranslationRefreshTime ||
    timeNow - parseInt(lastTranslationRefreshTime) > 10000
  ) {
    localStorage.setItem("lastTranslationRefreshTime", timeNow.toString());
    window.location.reload();
    return "";
  } else {
    console.error("Cannot find dynamic translation for " + translationKey);
    return translationKey;
  }
}
